import React from 'react';
import { Link } from 'react-router-dom';
import { css, cx } from 'linaria';
import { theme } from '../../Theme';

const elevatePaginationDotStyle = css`
  width: fit-content;
  height: 28px;
  background: #f8f8f8;
  color: #888;
  border-radius: 2px;
  line-height: 1;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  transition: all 0.2s ease;
  padding: 0 12px;
  text-decoration: none;

  ${theme.below.md} {
    padding: 0 8px;
    height: 24px;
    font-size: 11px;
  }

  span {
    padding-top: 2px;
    white-space: nowrap;
  }

  &:hover {
    background: #e0e0e0;
    color: #666;
  }

  &:active {
    transform: scale(1.05);
  }

  &.active {
    background: #ddd;
    color: #333;
    transform: scale(1.05);
  }

  &.no-click {
    pointer-events: none;

    span {
      padding-top: 0;
      padding-bottom: 2px;
      font-weight: 400;
      color: #bbb;
    }
  }
`;

/**
 * Renders a pagination dot component.
 *
 * @param {Object} props - The component props.
 * @param {string} props.value - The value of the pagination dot.
 * @param {boolean} props.active - Indicates if the pagination dot is active.
 * @param {Object} props.to - React Router location for the page link.
 * @param {function} props.onNavigate - Called before navigating to scroll the list into view.
 * @returns {JSX.Element} The rendered pagination dot component.
 */
export const ElevatePaginationDot = ({ value, active, to, onNavigate }) => {
  const isEllipsis = value === '...';
  const className = cx(
    'pagination-dot',
    `pagination-dot-${value}`,
    elevatePaginationDotStyle,
    active && 'active',
    isEllipsis && 'no-click'
  );

  if (isEllipsis || active) {
    return (
      <span className={className} aria-current={active ? 'page' : undefined}>
        <span>{value}</span>
      </span>
    );
  }

  return (
    <Link
      className={className}
      to={to}
      onClick={() => onNavigate?.(value)}
    >
      <span>{value}</span>
    </Link>
  );
};
